import React, { useState, useEffect } from 'react';

const API_URL = '/api/content';

const HowToWork = () => {
  const [reasons, setReasons] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetch(`${API_URL}/howToWork`);
      const data = await res.json();
      if (data && Array.isArray(data) && data.length > 0) {
        setReasons(data);
      } else {
        setReasons([
          { title: "Fast Response", description: "Quote within 1 week. Accelerate your project timeline.", icon: "M13 10V3L4 14h7v7l9-11h-7z" },
          { title: "High Quality", description: "10+ years experience engineers from Japanese companies.", icon: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806" },
          { title: "Scalability", description: "Flexible team expansion. Partnered with top-tier factories.", icon: "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6z" },
          { title: "Cost Effective", description: "30-40% cost reduction with Japanese quality standards.", icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1" }
        ]);
      }
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const getIcon = (iconPath) => {
    return (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={iconPath} />
      </svg>
    );
  };

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-6">
            <div className="flex-1 h-px bg-gray-300"></div>
            <h2 className="text-4xl font-bold text-gray-900 px-8">WHY CHOOSE US</h2>
            <div className="flex-1 h-px bg-gray-300"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className={`rounded-lg p-6 text-left ${
                index % 2 === 0 
                  ? 'bg-gradient-to-br from-pink-600 to-pink-700 text-white' 
                  : 'bg-white border-2 border-gray-200 text-gray-900'
              }`}
            >
              <div className="flex justify-center mb-4">
                <div className={`rounded-full p-3 ${index % 2 === 0 ? 'bg-white/20 text-white' : 'bg-pink-600 text-white'}`}>
                  {getIcon(reason.icon)}
                </div>
              </div>
              <h3 className="font-bold text-lg mb-3 text-center">{reason.title}</h3>
              <p className={`text-sm leading-relaxed text-center ${index % 2 === 0 ? 'text-white/90' : 'text-gray-600'}`}>
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToWork;
